export function startsWithCapital(word: string) {
  return word.charCodeAt(0) >= 65 && word.charCodeAt(0) <= 90
}

export function camelCaseToSpaced (camel: string) {
  return [...camel].reduce((acc, curr) => startsWithCapital(curr)
    ? `${acc} ${curr}`
    : `${acc}${curr}`
  , '').trim()
}
